import React from 'react';

export default function InputNumberNoScroll({ className = "", onKeyDown, onWheel, ...props }) {
  return (
    <input
      type="number"
      // Combina la clase que recibe (className) con "no-spinners"
      className={`no-spinners ${className}`} 
      
      // Bloquea el scroll del mouse (quita el foco)
      onWheel={(e) => {
        e.target.blur();
        if (onWheel) onWheel(e); 
      }}
      
      // Bloquea las flechas del teclado
      onKeyDown={(e) => {
        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
          e.preventDefault();
        }
        if (onKeyDown) onKeyDown(e);
      }}
      
      {...props} 
    />
  );
}